<template>
  <section :class="embedded ? 'mr-booking-embed' : 'dp-layout mr-page-layout'">
    <section :class="embedded ? '' : 'dp-right mr-module'">
      <div v-if="!embedded" class="page-header">
        <div>
          <div class="header-title-bar">
            <span class="header-icon-bar"></span>
            <h3>日程看板代订</h3>
          </div>
          <p class="page-desc">左侧选会议室，右侧点选或拖选时段代教师预约</p>
        </div>
        <div v-if="schoolId" class="page-header__actions">
          <el-button-group>
            <el-button size="small" icon="el-icon-arrow-left" :disabled="!canShiftPrev" @click="shiftDate(-1)" />
            <el-button size="small" @click="goToday">今天</el-button>
            <el-button size="small" icon="el-icon-arrow-right" @click="shiftDate(1)" />
          </el-button-group>
          <span class="qb-date-picker-wrap">
            <i class="el-icon-date"></i>
            <el-date-picker v-model="selectedDate" type="date" value-format="yyyy-MM-dd"
              size="small" class="qb-date-picker" style="width: 140px;"
              :picker-options="datePickerOptions" @change="loadTimeline" />
          </span>
          <el-button type="primary" size="small" class="qb-refresh-btn" @click="loadTimeline">
            <i class="el-icon-refresh"></i> 刷新
          </el-button>
        </div>
      </div>

      <div v-if="!schoolId" class="empty-tip">请在顶部选择学校后查看日程看板</div>

      <el-card v-else shadow="never" :class="['mr-panel', 'qb-panel', { 'is-embedded': embedded }]">
        <div :class="['qb-panel-inner', { 'is-embedded': embedded }]">
        <div v-if="embedded" class="qb-toolbar">
          <div class="qb-toolbar__room">
            <template v-if="timeline && timeline.Rooms && timeline.Rooms.length">
              <span class="qb-toolbar__room-label">会议室</span>
              <el-select v-model="selectedRoomId" size="small" filterable class="qb-toolbar__room-ctrl"
                placeholder="请选择会议室" :title="activeRoom ? embeddedRoomOptionLabel(activeRoom) : ''">
                <el-option v-for="room in timeline.Rooms" :key="room.RoomId"
                  :label="room.Name" :value="room.RoomId">
                  <span class="qb-room-option">
                    <span class="qb-room-option__name">{{ room.Name }}</span>
                    <span class="qb-room-option__meta">{{ room.Capacity }}人 · 当日{{ roomBookingCount(room) }}场</span>
                  </span>
                </el-option>
              </el-select>
              <span v-if="activeRoom" class="qb-toolbar__room-meta">
                {{ activeRoom.Capacity }}人<span v-if="roomBookingCount(activeRoom)"> · 当日{{ roomBookingCount(activeRoom) }}场</span>
              </span>
            </template>
          </div>
          <div class="qb-toolbar__date">
            <button type="button" class="qb-nav-btn" aria-label="前一天" :disabled="!canShiftPrev" @click="shiftDate(-1)">
              <i class="el-icon-arrow-left"></i>
            </button>
            <div class="qb-toolbar__date-main">
              <span class="qb-toolbar__day">{{ dateTitle }}</span>
              <span class="qb-toolbar__sub">{{ dayRangeLabel }} · 共 {{ bookingCount }} 场</span>
            </div>
            <button type="button" class="qb-nav-btn" aria-label="后一天" @click="shiftDate(1)">
              <i class="el-icon-arrow-right"></i>
            </button>
          </div>
          <div class="qb-toolbar__actions">
            <el-button size="small" round @click="goToday">今天</el-button>
            <span class="qb-date-picker-wrap">
              <i class="el-icon-date"></i>
              <el-date-picker v-model="selectedDate" type="date" value-format="yyyy-MM-dd"
                size="small" class="qb-date-picker"
                :picker-options="datePickerOptions" @change="loadTimeline" />
            </span>
            <el-button type="primary" size="small" round class="qb-refresh-btn" @click="loadTimeline">
              <i class="el-icon-refresh"></i> 刷新
            </el-button>
          </div>
        </div>
        <div v-else class="qb-meta">
          <div class="qb-meta__left">
            <span class="qb-meta__date">{{ dateTitle }}</span>
            <span class="qb-meta__sep">·</span>
            <span>{{ dayRangeLabel }}</span>
            <span class="qb-meta__sep">·</span>
            <span>共 {{ bookingCount }} 场预约</span>
          </div>
          <div class="qb-meta__actions">
            <el-button-group>
              <el-button size="mini" icon="el-icon-arrow-left" :disabled="!canShiftPrev" @click="shiftDate(-1)" />
              <el-button size="mini" @click="goToday">今天</el-button>
              <el-button size="mini" icon="el-icon-arrow-right" @click="shiftDate(1)" />
            </el-button-group>
            <span class="qb-date-picker-wrap">
              <i class="el-icon-date"></i>
              <el-date-picker v-model="selectedDate" type="date" value-format="yyyy-MM-dd"
                size="mini" class="qb-date-picker"
                :picker-options="datePickerOptions" @change="loadTimeline" />
            </span>
            <el-button type="primary" size="mini" class="qb-refresh-btn" @click="loadTimeline">
              <i class="el-icon-refresh"></i> 刷新
            </el-button>
          </div>
        </div>

        <div :class="['qb-panel-content', { 'is-embedded': embedded, 'qb-embed-scroll': embedded }]" v-loading="loading">
        <div v-if="timeline && timeline.Rooms && timeline.Rooms.length" :class="['qb-split', { 'is-embedded': embedded }]">
          <!-- 左侧：会议室列表（独立页） -->
          <aside v-if="!embedded" class="qb-rooms">
            <div class="qb-rooms__title">会议室</div>
            <button v-for="room in timeline.Rooms" :key="room.RoomId" type="button"
              :class="['qb-room-item', { 'is-active': room.RoomId === selectedRoomId }]"
              @click="selectRoom(room.RoomId)">
              <span class="qb-room-item__name">{{ room.Name }}</span>
              <span class="qb-room-item__meta">
                {{ room.Capacity }}人
                <el-tag v-if="room.RequireApproval" size="mini" type="warning" effect="plain">审批</el-tag>
              </span>
              <span v-if="roomBookingCount(room)" class="qb-room-item__badge">{{ roomBookingCount(room) }}</span>
            </button>
          </aside>

          <!-- 右侧：单室时间条 + 预约列表 -->
          <main v-if="activeRoom" :class="['qb-main', { 'is-embedded': embedded }]">
            <div class="qb-main__toolbar">
              <div class="qb-main__intro">
                <h4 v-if="!embedded" class="qb-main__title">{{ activeRoom.Name }}</h4>
                <p class="qb-main__hint">
                  <template v-if="isSelectedPast">当前为过去日期，仅可查看预约，不可代订；请点「今天」或切到未来日期</template>
                  <template v-else-if="embedded">仅绿色格可代订；灰白格为已过/未开放；红/黄格与下方列表可点选联动（看板仅 {{ dayRangeLabel }}）</template>
                  <template v-else>点击或拖选绿色空闲格代订；{{ dayRangeLabel }}，灰白格为已过或未开放</template>
                </p>
              </div>
              <div class="qb-legend">
                <span><i class="qb-dot is-free"></i>空闲</span>
                <span><i class="qb-dot is-busy"></i>占用</span>
                <span><i class="qb-dot is-pending"></i>待审</span>
                <span><i class="qb-dot is-past"></i>已过</span>
                <span><i class="qb-dot is-closed"></i>未开放</span>
                <el-button v-if="isSelectedToday" type="text" size="mini" class="qb-legend__now"
                  @click="scheduleScrollToNow">定位到现在</el-button>
              </div>
            </div>

            <div :class="['qb-strip-wrap', { 'is-fluid': embedded }]">
              <div :class="['qb-strip-scroll', { 'is-fluid': embedded }]" ref="stripScroll"
                @wheel="onStripWheel" @scroll="onStripScroll">
                <div class="qb-strip" :style="stripWidthStyle">
                  <div class="qb-strip__hours" :style="hourGridStyle">
                    <div v-for="h in hourLabels" :key="h" class="qb-strip__hour" :style="hourSpanStyle">{{ h }}</div>
                  </div>
                  <div class="qb-strip__track" :style="trackGridStyle" @mouseleave="onRowMouseLeave">
                    <div v-if="isSelectedToday" class="qb-now" :style="nowLineStyle">
                      <span class="qb-now__bubble">现在</span>
                      <span class="qb-now__line" aria-hidden="true"></span>
                    </div>
                    <div class="qb-events">
                      <div v-for="bk in activeRoom.Bookings" :key="bk.BookingId"
                        :class="['qb-event', bk.Status === 10 ? 'is-pending' : '', { 'is-selected': selectedBookingId === bk.BookingId }]"
                        :style="blockStyle(bk)"
                        :title="`${bk.Subject}（${bk.BookerName}）`"
                        @click.stop="selectBooking(bk)">
                        <span v-if="!embedded" class="qb-event__title">{{ bk.Subject }}</span>
                      </div>
                    </div>
                    <div v-for="(slot, idx) in activeSlots" :key="`slot-${idx}`"
                      :class="cellClass(activeRoom, slot, idx)"
                      :title="slot.title"
                      @mousedown="onSlotMouseDown(activeRoom, slot, idx)"
                      @mouseenter="onSlotMouseEnter(activeRoom, slot, idx)"
                      @mouseup.stop="onSlotMouseUp(activeRoom, slot, idx, $event)"
                      @click.stop="onSlotClick(activeRoom, slot, idx)"></div>
                  </div>
                </div>
              </div>
              <div v-show="stripScrollOverflow" class="qb-scroll-rail">
                <div class="qb-scroll-rail__track" ref="scrollRailTrack" @click="onRailTrackClick">
                  <div class="qb-scroll-rail__thumb" :style="scrollRailThumbStyle"
                    @mousedown.stop="onRailThumbMouseDown"></div>
                </div>
              </div>
            </div>

            <div :class="['qb-list', { 'is-compact': embedded }]">
              <div class="qb-list__head">
                <span>
                  <i class="el-icon-tickets"></i> 当日预约
                </span>
                <span class="qb-list__count">（{{ allDayBookings.length }} 场）</span>
              </div>
              <div v-if="allDayBookings.length" class="qb-list__toolbar">
                <el-input v-model="dayBookingKeyword" size="mini" clearable
                  placeholder="搜索主题/预约人" class="qb-list__search" @input="onDayBookingFilterChange" />
                <el-select v-model="dayBookingStatusFilter" size="mini" clearable
                  placeholder="状态" class="qb-list__status" @change="onDayBookingFilterChange">
                  <el-option label="有效" :value="30" />
                  <el-option label="待审核" :value="10" />
                  <el-option label="已取消" :value="50" />
                  <el-option label="爽约" :value="40" />
                  <el-option label="已拒绝" :value="20" />
                </el-select>
              </div>
              <div v-if="filteredDayBookings.length" :class="['qb-list__body', { 'is-chips': embedded, 'is-paged': embedded }]">
                <div v-for="bk in paginatedDayBookings" :key="bk.BookingId"
                  :ref="`booking-item-${bk.BookingId}`"
                  :class="bookingCardClass(bk)"
                  @click="selectBooking(bk)">
                  <div v-if="embedded" class="qb-booking__head">
                    <div class="qb-booking__time">{{ eventTimeLabel(bk) }}</div>
                    <div class="qb-booking__tags">
                      <el-tag v-if="!isBookingInBoardRange(bk)" size="mini" type="info" effect="plain">看板外</el-tag>
                      <el-tag :type="bookingStatusTagType(bk.Status)" size="mini" effect="plain">
                        {{ bookingStatusText(bk.Status) }}
                      </el-tag>
                    </div>
                  </div>
                  <template v-else>
                    <div class="qb-booking__time">{{ eventTimeLabel(bk) }}</div>
                  </template>
                  <div class="qb-booking__info">
                    <div class="qb-booking__subject">{{ bk.Subject }}</div>
                    <div class="qb-booking__meta">
                      {{ bk.BookerName }}
                      <template v-if="!embedded"> · {{ bookingStatusText(bk.Status) }}</template>
                    </div>
                  </div>
                  <el-button v-if="canCancelBooking(bk)" type="text" size="mini" class="qb-booking__cancel"
                    :loading="cancelingBookingId === bk.BookingId" @click.stop="cancelBooking(bk)">取消</el-button>
                </div>
              </div>
              <div v-else-if="allDayBookings.length" class="qb-list__empty is-compact">
                <i class="el-icon-search"></i>
                <span>无匹配的预约</span>
              </div>
              <div v-else :class="['qb-list__empty', { 'is-compact': embedded }]">
                <i class="el-icon-document"></i>
                <span>暂无预约，点击上方时间轴绿色格即可代订</span>
              </div>
              <div v-if="filteredDayBookings.length > dayBookingPageSize" class="qb-list__pager">
                <el-pagination small layout="total, prev, pager, next"
                  :current-page="dayBookingPage" :page-size="dayBookingPageSize"
                  :total="filteredDayBookings.length"
                  @current-change="onDayBookingPageChange" />
              </div>
            </div>
          </main>
        </div>

        <div v-else class="qb-empty">
          <i class="el-icon-date"></i>
          <p>当前学校暂无开放预约的会议室</p>
          <el-button type="primary" plain size="small" @click="goRoomList">去会议室列表</el-button>
        </div>
        </div>

        <div v-if="embedded" class="mr-booking-footer">
          <el-button @click="handleCancel">取消</el-button>
        </div>
        </div>
      </el-card>

      <el-dialog title="代订会议" :visible.sync="dialogVisible" width="560px" append-to-body
        :close-on-click-modal="false" destroy-on-close @closed="resetForm">
        <div v-if="dialogVisible" class="qb-dialog-summary">
          <span class="qb-dialog-summary__icon"><i class="el-icon-time"></i></span>
          <div class="qb-dialog-summary__body">
            <span class="qb-dialog-summary__room">{{ form.roomName }}</span>
            <span class="qb-dialog-summary__time">{{ selectedDate }} {{ formStartLabel }}–{{ formEndLabel }}</span>
          </div>
        </div>
        <el-form v-if="dialogVisible" :model="form" :rules="formRules" ref="form" label-width="96px" size="small">
          <el-form-item label="时长">
            <el-select v-model="form.durationMinutes" style="width: 140px;" @change="onDurationChange">
              <el-option v-for="m in durationOptions" :key="m" :label="`${m} 分钟`" :value="m" />
            </el-select>
          </el-form-item>
          <el-form-item label="预约人" prop="BookerTeacherMasterId">
            <MeetingRoomTeacherSelect v-model="form.BookerTeacherMasterId" :department-id="schoolId" />
          </el-form-item>
          <el-form-item label="会议主题" prop="Subject">
            <el-input v-model="form.Subject" placeholder="请输入会议主题" maxlength="200" />
          </el-form-item>
          <MeetingRoomParticipantPicker ref="participantPicker" v-model="participants"
            :school-id="schoolId" :room-id="form.RoomId || 0"
            :campus-id="bookingCampusId" :campus-name="bookingCampusName" />
          <MeetingRoomNotifyTypeField v-model="form.NotifyType" />
          <el-form-item label="备注">
            <el-input v-model="form.Remark" type="textarea" :rows="2" placeholder="可选" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="submitBooking">确认代订</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import axios from 'axios';
import { BaseApiUrl } from '../../api/base';
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps';
import { meetingBookingTimePickerOptions } from '../../utils/meetingRoomForm';

const apiBase = BaseApiUrl;
/** 看板展示 06:00–24:00；未开放时段仍按会议室开放时间标灰。最后更新：2026-07-19 */
const DAY_START_HOUR = 6;
const DAY_END_HOUR = 24;
/** 默认槽宽；有时间轴数据后以接口 SlotMinutes 为准（后端 15 分钟） */
const DEFAULT_SLOT_MINUTES = 15;
const SLOT_WIDTH = 48;

export default {
  name: 'MeetingQuickBooking',
  props: {
    embedded: { type: Boolean, default: false }
  },
  components: {
    MeetingRoomTeacherSelect: () => import('../../components/MeetingRoomTeacherSelect.vue'),
    MeetingRoomParticipantPicker: () => import('../../components/MeetingRoomParticipantPicker.vue'),
    MeetingRoomNotifyTypeField: () => import('../../components/MeetingRoomNotifyTypeField.vue')
  },
  data() {
    return {
      datePickerOptions: meetingBookingTimePickerOptions,
      selectedDate: '',
      selectedRoomId: null,
      timeline: null,
      loading: false,
      dialogVisible: false,
      submitLoading: false,
      cancelingBookingId: null,
      selectedBookingId: null,
      participants: [],
      nowTick: Date.now(),
      nowTimer: null,
      dragState: { active: false, roomId: null, startIdx: null, endIdx: null, moved: false },
      railDragState: { active: false, startX: 0, startScrollLeft: 0, maxScroll: 0, trackWidth: 0, thumbWidth: 0 },
      stripScrollState: { scrollWidth: 0, clientWidth: 0, scrollLeft: 0 },
      suppressNextClick: false,
      slotClickHandled: false,
      roomMetaById: {},
      roomMetaLoadedSchool: null,
      dayBookingKeyword: '',
      dayBookingStatusFilter: '',
      dayBookingPage: 1,
      dayBookingPageSize: 6,
      form: {
        RoomId: null,
        roomName: '',
        slotStart: null,
        durationMinutes: DEFAULT_SLOT_MINUTES,
        StartTime: '',
        EndTime: '',
        BookerTeacherMasterId: null,
        Subject: '',
        Remark: '',
        NotifyType: 1
      },
      formRules: {
        BookerTeacherMasterId: [{ required: true, message: '请选择预约人', trigger: 'change' }],
        Subject: [{ required: true, message: '请输入会议主题', trigger: 'blur' }]
      }
    };
  },
  computed: {
    schoolId() {
      return resolveActiveSchoolId(this);
    },
    bookingCampusId() {
      const room = this.roomMetaById[this.form.RoomId];
      return room ? Number(room.CampusId) || 0 : 0;
    },
    bookingCampusName() {
      const room = this.roomMetaById[this.form.RoomId];
      return (room && room.CampusName) || '';
    },
    durationOptions() {
      return [30, 60, 90, 120, 180, 240];
    },
    slotMinutes() {
      const v = Number(this.timeline && (this.timeline.SlotMinutes || this.timeline.slotMinutes));
      return v > 0 ? v : DEFAULT_SLOT_MINUTES;
    },
    activeRoom() {
      if (!this.timeline || !this.timeline.Rooms || !this.selectedRoomId) return null;
      return this.timeline.Rooms.find(r => r.RoomId === this.selectedRoomId) || null;
    },
    activeSlots() {
      if (!this.activeRoom) return [];
      return this.roomSlotsMap[this.activeRoom.RoomId] || [];
    },
    allDayBookings() {
      if (!this.activeRoom) return [];
      const list = this.activeRoom.DayBookings || this.activeRoom.dayBookings
        || this.activeRoom.Bookings || this.activeRoom.bookings || [];
      return [...list].sort((a, b) => new Date(a.StartTime) - new Date(b.StartTime));
    },
    sortedBookings() {
      return this.allDayBookings;
    },
    filteredDayBookings() {
      const keyword = (this.dayBookingKeyword || '').trim().toLowerCase();
      return this.allDayBookings.filter(bk => {
        if (this.dayBookingStatusFilter !== '' && this.dayBookingStatusFilter != null) {
          if (Number(bk.Status) !== Number(this.dayBookingStatusFilter)) return false;
        }
        if (!keyword) return true;
        const subject = (bk.Subject || '').toLowerCase();
        const booker = (bk.BookerName || '').toLowerCase();
        return subject.includes(keyword) || booker.includes(keyword);
      });
    },
    paginatedDayBookings() {
      const start = (this.dayBookingPage - 1) * this.dayBookingPageSize;
      return this.filteredDayBookings.slice(start, start + this.dayBookingPageSize);
    },
    formStartLabel() {
      return this.form.slotStart ? this.formatTime(this.form.slotStart) : '-';
    },
    formEndLabel() {
      if (!this.form.slotStart || !this.form.durationMinutes) return '-';
      const end = new Date(this.form.slotStart.getTime() + this.form.durationMinutes * 60000);
      return this.formatTime(end);
    },
    hourLabels() {
      const labels = [];
      for (let h = DAY_START_HOUR; h < DAY_END_HOUR; h += 1) {
        labels.push(`${String(h).padStart(2, '0')}:00`);
      }
      return labels;
    },
    totalSlots() {
      return ((DAY_END_HOUR - DAY_START_HOUR) * 60) / this.slotMinutes;
    },
    slotsPerHour() {
      return 60 / this.slotMinutes;
    },
    dayRangeLabel() {
      return `${String(DAY_START_HOUR).padStart(2, '0')}:00–${String(DAY_END_HOUR).padStart(2, '0')}:00`;
    },
    slotWidthPx() {
      return this.embedded ? 40 : SLOT_WIDTH;
    },
    slotHeightPx() {
      return this.embedded ? 60 : 56;
    },
    stripContentWidthPx() {
      const gap = 2;
      // 与 .qb-strip__track 左右 padding 对齐：embedded 8+8，独立页 6+6
      const padding = this.embedded ? 16 : 12;
      return this.totalSlots * this.slotWidthPx + (this.totalSlots - 1) * gap + padding;
    },
    hourGridStyle() {
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${this.totalSlots}, ${this.slotWidthPx}px)`,
        gap: '2px',
        gridAutoRows: 'minmax(18px, auto)'
      };
    },
    trackGridStyle() {
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${this.totalSlots}, ${this.slotWidthPx}px)`,
        gap: '2px',
        gridAutoRows: `${this.slotHeightPx}px`
      };
    },
    stripWidthStyle() {
      const w = this.stripContentWidthPx;
      return { width: `${w}px`, minWidth: `${w}px`, maxWidth: 'none' };
    },
    hourSpanStyle() {
      return { gridColumn: `span ${this.slotsPerHour}` };
    },
    stripScrollOverflow() {
      const s = this.stripScrollState;
      return s.scrollWidth > s.clientWidth + 1;
    },
    scrollRailThumbStyle() {
      const { scrollWidth, clientWidth, scrollLeft } = this.stripScrollState;
      const maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 0) return { display: 'none' };
      const thumbWidthPct = Math.max((clientWidth / scrollWidth) * 100, 10);
      const scrollPct = scrollLeft / maxScroll;
      const thumbLeftPct = scrollPct * (100 - thumbWidthPct);
      return { width: `${thumbWidthPct}%`, left: `${thumbLeftPct}%` };
    },
    bookingCount() {
      if (this.embedded) {
        return this.activeRoom ? this.roomDayBookingCount(this.activeRoom) : 0;
      }
      if (!this.timeline || !this.timeline.Rooms) return 0;
      return this.timeline.Rooms.reduce((sum, room) => sum + this.roomDayBookingCount(room), 0);
    },
    dateTitle() {
      if (!this.selectedDate) return '';
      const parts = this.selectedDate.split('-');
      if (parts.length !== 3) return this.selectedDate;
      const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const d = new Date(`${this.selectedDate}T12:00:00`);
      return `${Number(parts[1])}月${Number(parts[2])}日 ${week[d.getDay()]}`;
    },
    isSelectedToday() {
      if (!this.selectedDate) return false;
      return this.selectedDate === this.todayDateStr;
    },
    todayDateStr() {
      const t = new Date();
      return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')}`;
    },
    isSelectedPast() {
      if (!this.selectedDate) return false;
      return this.selectedDate < this.todayDateStr;
    },
    canShiftPrev() {
      if (!this.selectedDate) return false;
      return this.selectedDate > this.todayDateStr;
    },
    nowLineStyle() {
      const now = new Date(this.nowTick);
      const base = new Date(`${this.selectedDate}T00:00:00`);
      const start = new Date(base);
      start.setHours(DAY_START_HOUR, 0, 0, 0);
      const end = new Date(base);
      end.setHours(DAY_END_HOUR, 0, 0, 0);
      if (now < start || now >= end) return { display: 'none' };
      const pct = ((now - start) / (end - start)) * 100;
      return { left: `${pct}%` };
    },
    roomSlotsMap() {
      const map = {};
      if (!this.timeline || !this.timeline.Rooms || !this.selectedDate) return map;
      this.timeline.Rooms.forEach(room => {
        map[room.RoomId] = this.buildSlotsForRoom(room);
      });
      return map;
    }
  },
  watch: {
    schoolId(val, oldVal) {
      if (val === oldVal) return;
      this.timeline = null;
      this.selectedRoomId = null;
      this.participants = [];
      this.roomMetaById = {};
      this.roomMetaLoadedSchool = null;
      if (val) {
        this.loadRoomMeta();
        this.loadTimeline();
      }
    },
    selectedRoomId(val, oldVal) {
      if (val === oldVal) return;
      this.selectedBookingId = null;
      this.$nextTick(() => this.updateStripScrollMetrics());
      this.scheduleScrollToNow();
    }
  },
  mounted() {
    const t = new Date();
    this.selectedDate = `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')}`;
    window.addEventListener('mouseup', this.onWindowMouseUp);
    window.addEventListener('mousemove', this.onRailDragMove);
    window.addEventListener('resize', this.updateStripScrollMetrics);
    this.nowTimer = window.setInterval(() => { this.nowTick = Date.now(); }, 30000);
    if (this.schoolId) this.loadTimeline();
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.onWindowMouseUp);
    window.removeEventListener('mousemove', this.onRailDragMove);
    window.removeEventListener('resize', this.updateStripScrollMetrics);
    if (this.nowTimer) window.clearInterval(this.nowTimer);
  },
  methods: {
    selectRoom(roomId) {
      this.selectedRoomId = roomId;
      this.selectedBookingId = null;
      this.resetDayBookingFilters();
    },
    syncSelectedRoom() {
      if (!this.timeline || !this.timeline.Rooms || !this.timeline.Rooms.length) {
        this.selectedRoomId = null;
        return;
      }
      const exists = this.timeline.Rooms.some(r => r.RoomId === this.selectedRoomId);
      if (!exists) this.selectedRoomId = this.timeline.Rooms[0].RoomId;
    },
    roomBookingCount(room) {
      return this.roomDayBookingCount(room);
    },
    roomDayBookingCount(room) {
      const list = (room && (room.DayBookings || room.dayBookings || room.Bookings || room.bookings)) || [];
      return list.length;
    },
    embeddedRoomOptionLabel(room) {
      if (!room) return '';
      const count = this.roomBookingCount(room);
      const bookingText = count > 0 ? ` · 当日${count}场` : '';
      return `${room.Name}（${room.Capacity}人${bookingText}）`;
    },
    bookingStatusText(status) {
      const map = { 10: '待审核', 30: '有效', 20: '已拒绝', 40: '爽约', 50: '已取消' };
      return map[status] || '有效';
    },
    bookingStatusTagType(status) {
      const map = { 10: 'warning', 30: 'success', 20: 'danger', 40: 'info', 50: 'info' };
      return map[status] || 'info';
    },
    bookingCardClass(bk) {
      const status = Number(bk.Status);
      return [
        'qb-booking',
        status === 10 ? 'is-pending' : '',
        status === 50 ? 'is-cancelled' : '',
        status === 40 ? 'is-noshow' : '',
        status === 20 ? 'is-rejected' : '',
        { 'is-chip': this.embedded, 'is-selected': this.selectedBookingId === bk.BookingId }
      ];
    },
    resetDayBookingFilters() {
      this.dayBookingKeyword = '';
      this.dayBookingStatusFilter = '';
      this.dayBookingPage = 1;
    },
    onDayBookingFilterChange() {
      this.dayBookingPage = 1;
    },
    onDayBookingPageChange(page) {
      this.dayBookingPage = page;
    },
    canCancelBooking(bk) {
      if (!bk) return false;
      const status = Number(bk.Status);
      if (status !== 10 && status !== 30) return false;
      return bk.DisplayStatus !== 'ended';
    },
    cancelBooking(bk) {
      if (!this.canCancelBooking(bk) || this.cancelingBookingId) return;
      const label = bk.Subject || '该会议';
      this.$confirm(`确认取消「${label}」？`, '提示', { type: 'warning' }).then(() => {
        this.cancelingBookingId = bk.BookingId;
        axios.post(`${apiBase}/api/MeetingBooking/Cancel`, null, {
          params: { bookingId: bk.BookingId }
        }).then(res => {
          this.cancelingBookingId = null;
          if (res.data.success) {
            this.$message.success('取消成功');
            if (this.selectedBookingId === bk.BookingId) this.selectedBookingId = null;
            this.loadTimeline();
            this.$emit('success');
          } else {
            this.$message.error(res.data.msg || '取消失败');
          }
        }).catch(() => { this.cancelingBookingId = null; });
      }).catch(() => {});
    },
    shiftDate(delta) {
      const d = new Date(`${this.selectedDate}T12:00:00`);
      d.setDate(d.getDate() + delta);
      const next = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      if (delta < 0 && next < this.todayDateStr) return;
      this.selectedDate = next;
      this.loadTimeline();
    },
    goToday() {
      const t = new Date();
      this.selectedDate = `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')}`;
      this.loadTimeline();
    },
    eventTimeLabel(bk) {
      return `${this.formatTime(new Date(bk.StartTime))}–${this.formatTime(new Date(bk.EndTime))}`;
    },
    cellClass(room, slot, idx) {
      const cls = ['qb-cell', `is-${slot.status}`];
      if (idx % this.slotsPerHour === 0) cls.push('is-hour');
      if (slot.status === 'free') cls.push('is-clickable');
      if (slot.status === 'busy' || slot.status === 'pending') cls.push('is-selectable');
      if (slot.booking && slot.booking.BookingId === this.selectedBookingId) cls.push('is-booking-selected');
      if (slot.effectiveStart) cls.push('is-current');
      if (this.isSlotInDragSelection(room.RoomId, idx)) cls.push('is-selecting');
      return cls;
    },
    isSlotInDragSelection(roomId, idx) {
      if (!this.dragState.active || this.dragState.roomId !== roomId) return false;
      const lo = Math.min(this.dragState.startIdx, this.dragState.endIdx);
      const hi = Math.max(this.dragState.startIdx, this.dragState.endIdx);
      return idx >= lo && idx <= hi;
    },
    onSlotMouseDown(room, slot, idx) {
      if (slot.status !== 'free') return;
      this.dragState = { active: true, roomId: room.RoomId, room, startIdx: idx, endIdx: idx, moved: false };
    },
    onSlotMouseEnter(room, slot, idx) {
      if (!this.dragState.active || this.dragState.roomId !== room.RoomId || slot.status !== 'free') return;
      if (idx !== this.dragState.endIdx) this.dragState.moved = true;
      this.dragState.endIdx = idx;
    },
    getBookingNow() {
      const now = new Date();
      now.setSeconds(0, 0);
      now.setMilliseconds(0);
      return now;
    },
    getActualNow() {
      return new Date();
    },
    floorToMinute(d) {
      const t = new Date(d.getTime());
      t.setSeconds(0, 0);
      t.setMilliseconds(0);
      return t;
    },
    onRowMouseLeave() {},
    onWindowMouseUp() {
      if (this.railDragState.active) {
        this.railDragState = { active: false, startX: 0, startScrollLeft: 0, maxScroll: 0, trackWidth: 0, thumbWidth: 0 };
      }
      if (!this.dragState.active) return;
      const { room, startIdx, endIdx, moved } = this.dragState;
      this.dragState = { active: false, roomId: null, room: null, startIdx: null, endIdx: null, moved: false };
      if (!room || startIdx == null || endIdx == null) return;

      const slots = this.roomSlotsMap[room.RoomId] || [];
      if (!moved) {
        // 单击由格子 mouseup 处理，避免与 window 重复触发
        return;
      }

      const lo = Math.min(startIdx, endIdx);
      const hi = Math.max(startIdx, endIdx);
      for (let i = lo; i <= hi; i++) {
        if (!slots[i] || slots[i].status !== 'free') {
          this.$message.warning('拖选范围内存在不可预约时段');
          return;
        }
      }
      this.suppressNextClick = true;
      const startSlot = slots[lo];
      const endSlot = slots[hi];
      const start = this.resolveSlotStart(startSlot);
      const durationMinutes = Math.round((endSlot.slotEnd.getTime() - start.getTime()) / 60000);
      if (durationMinutes <= 0) return;
      this.tryOpenSlotBooking(room, startSlot, hi - lo + 1, start, durationMinutes);
    },
    tryOpenSlotBooking(room, slot, slotCount = 1, startOverride = null, durationOverride = null) {
      this.nowTick = Date.now();
      const start = startOverride || this.resolveSlotStart(slot);
      if (!start) return;
      const durationMinutes = durationOverride != null
        ? durationOverride
        : this.computeSlotDuration(slot, slotCount);
      if (durationMinutes <= 0) {
        this.$message.warning('该时段剩余可约时间不足');
        return;
      }
      this.slotClickHandled = true;
      this.selectedBookingId = null;
      this.openBookingDialog(room, start, durationMinutes);
    },
    computeSlotDuration(slot, slotCount = 1) {
      const start = this.resolveSlotStart(slot);
      const spanMinutes = slotCount * this.slotMinutes;
      if (slot.effectiveStart) {
        const remain = Math.round((slot.slotEnd.getTime() - start.getTime()) / 60000);
        return Math.max(1, Math.min(spanMinutes, remain));
      }
      return spanMinutes;
    },
    onSlotMouseUp(room, slot, idx, e) {
      if (e && e.button !== 0) return;
      // 灰白格 mousedown 不会启动拖选，仍需在 mouseup 给出反馈
      if (!this.dragState.active || this.dragState.roomId !== room.RoomId) {
        if (slot.status !== 'free') {
          this.suppressNextClick = true;
          this.notifySlotUnavailable(slot);
        }
        return;
      }
      const wasClick = !this.dragState.moved && this.dragState.startIdx === idx;
      this.dragState = { active: false, roomId: null, room: null, startIdx: null, endIdx: null, moved: false };
      if (!wasClick) return;
      this.suppressNextClick = true;
      this.slotClickHandled = true;
      this.activateSlot(room, slot);
    },
    onSlotClick(room, slot) {
      if (this.suppressNextClick) { this.suppressNextClick = false; return; }
      if (this.slotClickHandled) { this.slotClickHandled = false; return; }
      this.activateSlot(room, slot);
    },
    /** 时间格单击：空闲代订 / 占用联动列表 / 已过未开放提示。最后更新：2026-07-19 */
    activateSlot(room, slot) {
      if (slot.status === 'busy' || slot.status === 'pending') {
        if (slot.booking) this.selectBooking(slot.booking);
        return;
      }
      if (slot.status !== 'free') {
        this.notifySlotUnavailable(slot);
        return;
      }
      this.selectedBookingId = null;
      this.tryOpenSlotBooking(room, slot, 1);
    },
    notifySlotUnavailable(slot) {
      if (!slot) return;
      if (slot.status === 'past') {
        this.$message.info(this.isSelectedPast
          ? '过去日期不可代订，请切换到今天或未来日期'
          : '该时段已过，请选择绿色空闲格');
        return;
      }
      if (slot.status === 'closed') {
        this.$message.info('该时段不在会议室开放时间内');
      }
    },
    isBookingInBoardRange(bk) {
      if (!bk || !this.selectedDate) return false;
      const base = new Date(`${this.selectedDate}T00:00:00`);
      const rangeStart = new Date(base);
      rangeStart.setHours(DAY_START_HOUR, 0, 0, 0);
      const rangeEnd = new Date(base);
      rangeEnd.setHours(DAY_END_HOUR, 0, 0, 0);
      const bs = new Date(bk.StartTime);
      const be = new Date(bk.EndTime);
      return bs < rangeEnd && be > rangeStart;
    },
    selectBooking(bk) {
      if (!bk || !bk.BookingId) return;
      this.selectedBookingId = bk.BookingId;
      const status = Number(bk.Status);
      const inBoard = this.isBookingInBoardRange(bk);
      const onStrip = inBoard && (status === 10 || status === 30);
      this.$nextTick(() => {
        if (onStrip) {
          this.scrollStripToBooking(bk, { smooth: true });
        } else if (!inBoard) {
          this.$message.info(`「${bk.Subject || '该预约'}」时段 ${this.eventTimeLabel(bk)} 不在看板 ${this.dayRangeLabel} 内，无法在时间轴显示`);
        } else if (status === 50) {
          this.$message.info('已取消的预约不占用时间轴，仅可在下方列表查看');
        } else if (status === 20 || status === 40) {
          this.$message.info('该预约未占用时间轴，仅可在下方列表查看');
        }
        const ref = this.$refs[`booking-item-${bk.BookingId}`];
        const node = Array.isArray(ref) ? ref[0] : ref;
        if (node && node.scrollIntoView) {
          node.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
    },
    getEffectiveBookingStart(start) {
      const startAt = new Date(start.getTime());
      if (!this.isSelectedToday) return startAt;
      const now = this.getBookingNow();
      if (this.floorToMinute(startAt) < now) return new Date(now.getTime());
      return startAt;
    },
    alignStartForSubmit(start, now = null) {
      const startAt = new Date(start.getTime());
      if (!this.isSelectedToday) return startAt;
      const actualNow = now || this.getActualNow();
      const startMinute = this.floorToMinute(startAt);
      const nowMinute = this.floorToMinute(actualNow);
      if (startMinute < nowMinute) return new Date(actualNow.getTime());
      if (startAt < actualNow) return new Date(actualNow.getTime());
      return startAt;
    },
    buildSubmitTimeRange() {
      const now = this.getActualNow();
      const start = this.alignStartForSubmit(this.getEffectiveBookingStart(this.form.slotStart), now);
      const end = new Date(start.getTime() + this.form.durationMinutes * 60000);
      return { start, end, now };
    },
    resolveSlotStart(slot) {
      if (this.isSelectedPast) return null;
      const now = this.getBookingNow();
      if (this.isSelectedToday && slot.slotEnd && now >= slot.slotEnd) return null;
      if (this.isSelectedToday && slot.slotStart && slot.slotEnd && now >= slot.slotStart && now < slot.slotEnd) {
        return new Date(now.getTime());
      }
      if (slot.effectiveStart) return new Date(slot.effectiveStart.getTime());
      return new Date(slot.slotStart.getTime());
    },
    openBookingDialog(room, slotStart, durationMinutes) {
      this.form = {
        RoomId: room.RoomId,
        roomName: room.Name,
        slotStart: new Date(slotStart.getTime()),
        durationMinutes,
        StartTime: '', EndTime: '',
        BookerTeacherMasterId: null, Subject: '', Remark: '', NotifyType: 1
      };
      if (!this.syncTimeFromDuration(true)) return;
      this.participants = [];
      this.dialogVisible = true;
      this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate(); });
    },
    onDurationChange() { this.syncTimeFromDuration(true); },
    syncTimeFromDuration(showError) {
      if (!this.form.slotStart || !this.form.RoomId) return false;
      const start = this.getEffectiveBookingStart(this.form.slotStart);
      this.form.slotStart = start;
      const end = new Date(start.getTime() + this.form.durationMinutes * 60000);
      const dayEnd = new Date(`${this.selectedDate}T00:00:00`);
      dayEnd.setHours(DAY_END_HOUR, 0, 0, 0);
      if (end > dayEnd) {
        if (showError) this.$message.warning(`结束时间不能超过 ${DAY_END_HOUR}:00`);
        return false;
      }
      const check = this.validateSlotRange(this.form.RoomId, start, end);
      if (!check.ok) {
        if (showError) this.$message.warning(check.msg);
        return false;
      }
      this.form.StartTime = this.formatDateTime(start);
      this.form.EndTime = this.formatDateTime(end);
      return true;
    },
    validateSlotRange(roomId, start, end, useActualNow = false, nowOverride = null) {
      const room = (this.timeline && this.timeline.Rooms || []).find(r => r.RoomId === roomId);
      if (!room) return { ok: true };
      const now = nowOverride || (useActualNow ? this.getActualNow() : this.getBookingNow());
      const startMinute = this.floorToMinute(start);
      const nowMinute = this.floorToMinute(now);
      if (this.isSelectedPast) {
        return { ok: false, msg: '不能预约过去的日期' };
      }
      if (this.isSelectedToday && end <= now) {
        return { ok: false, msg: '结束时间不能早于或等于当前时间' };
      }
      if (this.isSelectedToday && startMinute < nowMinute) {
        return { ok: false, msg: '开始时间不能早于当前时间' };
      }
      if (!this.isRangeInOpen(room, start, end)) {
        return { ok: false, msg: '不在会议室开放时间内' };
      }
      const conflict = this.findBookingInRange(room, start, end);
      if (conflict) {
        return { ok: false, msg: `与「${conflict.Subject || '已有预约'}」冲突，请调整时长` };
      }
      return { ok: true };
    },
    buildParticipants() {
      const picker = this.$refs.participantPicker;
      return picker ? picker.buildPayload() : [];
    },
    loadRoomMeta() {
      if (!this.schoolId) return;
      if (this.roomMetaLoadedSchool === this.schoolId && Object.keys(this.roomMetaById).length) return;
      axios.get(`${apiBase}/api/MeetingRoom/GetList`, {
        params: { page: 1, intPageSize: 500, departmentId: this.schoolId }
      }).then(res => {
        const rows = (res.data.success && res.data.response && res.data.response.data) || [];
        const map = {};
        rows.forEach(room => { map[room.Id] = room; });
        this.roomMetaById = map;
        this.roomMetaLoadedSchool = this.schoolId;
      }).catch(() => {});
    },
    loadTimeline() {
      if (!this.schoolId || !this.selectedDate) return;
      this.loadRoomMeta();
      this.loading = true;
      this.resetDayBookingFilters();
      axios.get(`${apiBase}/api/MeetingBooking/GetTimeline`, {
        params: { schoolId: this.schoolId, campusId: 0, date: this.selectedDate }
      }).then(res => {
        this.loading = false;
          if (res.data.success) {
            this.timeline = res.data.response;
            this.selectedBookingId = null;
            this.syncSelectedRoom();
          this.$nextTick(() => {
            this.scheduleScrollToNow();
            this.updateStripScrollMetrics();
          });
        } else {
          this.timeline = null;
          this.$message.error(res.data.msg || '加载失败');
        }
      }).catch(() => { this.loading = false; this.timeline = null; });
    },
    goRoomList() { this.$router.push('/MeetingRoom/RoomList'); },
    handleCancel() {
      this.$emit('cancel');
    },
    goGettingStarted() { this.$router.push('/MeetingRoom/GettingStarted'); },
    onStripWheel(e) {
      const el = e.currentTarget;
      if (!el || el.scrollWidth <= el.clientWidth + 1) return;
      if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
      el.scrollLeft += e.deltaY;
      e.preventDefault();
    },
    scrollStripToNow(options = {}) {
      const smooth = !!options.smooth;
      const el = this.$refs.stripScroll;
      if (!el || !this.isSelectedToday) return;
      const now = new Date(this.nowTick);
      const base = new Date(`${this.selectedDate}T00:00:00`);
      const start = new Date(base);
      start.setHours(DAY_START_HOUR, 0, 0, 0);
      const end = new Date(base);
      end.setHours(DAY_END_HOUR, 0, 0, 0);
      if (now < start) {
        el.scrollLeft = 0;
        this.updateStripScrollMetrics();
        return;
      }
      if (now >= end) {
        el.scrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);
        this.updateStripScrollMetrics();
        return;
      }
      const contentWidth = this.stripContentWidthPx;
      const maxScroll = Math.max(0, contentWidth - el.clientWidth);
      if (maxScroll <= 0) return;
      const pct = (now.getTime() - start.getTime()) / (end.getTime() - start.getTime());
      const leadRatio = 0.28;
      const target = pct * contentWidth - el.clientWidth * leadRatio;
      const left = Math.max(0, Math.min(maxScroll, target));
      if (smooth && el.scrollTo) {
        el.scrollTo({ left, behavior: 'smooth' });
      } else {
        el.scrollLeft = left;
      }
      this.updateStripScrollMetrics();
    },
    scrollStripToBooking(bk, options = {}) {
      const el = this.$refs.stripScroll;
      if (!el || !bk) return;
      const base = new Date(`${this.selectedDate}T00:00:00`);
      const rangeStart = new Date(base);
      rangeStart.setHours(DAY_START_HOUR, 0, 0, 0);
      const rangeEnd = new Date(base);
      rangeEnd.setHours(DAY_END_HOUR, 0, 0, 0);
      const bookingStart = new Date(bk.StartTime);
      const contentWidth = this.stripContentWidthPx;
      const maxScroll = Math.max(0, contentWidth - el.clientWidth);
      if (maxScroll <= 0) return;
      const totalMs = rangeEnd.getTime() - rangeStart.getTime();
      if (totalMs <= 0) return;
      const pct = Math.max(0, Math.min(1, (bookingStart.getTime() - rangeStart.getTime()) / totalMs));
      const leadRatio = 0.2;
      const target = pct * contentWidth - el.clientWidth * leadRatio;
      const left = Math.max(0, Math.min(maxScroll, target));
      if (options.smooth && el.scrollTo) {
        el.scrollTo({ left, behavior: 'smooth' });
      } else {
        el.scrollLeft = left;
      }
      this.updateStripScrollMetrics();
    },
    /** 弹窗/布局渲染完成后多次定位到现在，避免 scrollWidth 尚未就绪 */
    scheduleScrollToNow() {
      if (!this.isSelectedToday) return;
      const run = (smooth) => this.scrollStripToNow({ smooth });
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          run(false);
          requestAnimationFrame(() => run(false));
        });
      });
      [100, 280, 520].forEach((ms, idx) => {
        window.setTimeout(() => run(idx === 2), ms);
      });
    },
    updateStripScrollMetrics() {
      const el = this.$refs.stripScroll;
      if (!el) {
        this.stripScrollState = { scrollWidth: 0, clientWidth: 0, scrollLeft: 0 };
        return;
      }
      this.stripScrollState = {
        scrollWidth: el.scrollWidth,
        clientWidth: el.clientWidth,
        scrollLeft: el.scrollLeft
      };
    },
    onStripScroll() {
      this.updateStripScrollMetrics();
    },
    onRailTrackClick(e) {
      if (e.target.classList.contains('qb-scroll-rail__thumb')) return;
      const el = this.$refs.stripScroll;
      const track = this.$refs.scrollRailTrack;
      if (!el || !track) return;
      const rect = track.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const maxScroll = el.scrollWidth - el.clientWidth;
      const trackWidth = track.clientWidth;
      const thumbWidth = Math.max(56, (el.clientWidth / el.scrollWidth) * trackWidth);
      const targetThumbLeft = clickX - thumbWidth / 2;
      const maxThumbLeft = trackWidth - thumbWidth;
      const ratio = maxThumbLeft > 0 ? Math.max(0, Math.min(1, targetThumbLeft / maxThumbLeft)) : 0;
      el.scrollLeft = ratio * maxScroll;
      this.updateStripScrollMetrics();
    },
    onRailThumbMouseDown(e) {
      e.preventDefault();
      const el = this.$refs.stripScroll;
      const track = this.$refs.scrollRailTrack;
      if (!el || !track) return;
      const maxScroll = el.scrollWidth - el.clientWidth;
      const trackWidth = track.clientWidth;
      const thumbWidth = Math.max(56, (el.clientWidth / el.scrollWidth) * trackWidth);
      this.railDragState = {
        active: true,
        startX: e.clientX,
        startScrollLeft: el.scrollLeft,
        maxScroll,
        trackWidth,
        thumbWidth
      };
    },
    onRailDragMove(e) {
      if (!this.railDragState.active || !this.$refs.stripScroll) return;
      const { startX, startScrollLeft, maxScroll, trackWidth, thumbWidth } = this.railDragState;
      const maxThumbLeft = trackWidth - thumbWidth;
      if (maxThumbLeft <= 0) return;
      const deltaX = e.clientX - startX;
      const scrollDelta = (deltaX / maxThumbLeft) * maxScroll;
      this.$refs.stripScroll.scrollLeft = Math.max(0, Math.min(maxScroll, startScrollLeft + scrollDelta));
      this.updateStripScrollMetrics();
    },
    buildSlotsForRoom(room) {
      const slots = [];
      const base = new Date(`${this.selectedDate}T00:00:00`);
      const rangeStart = new Date(base);
      rangeStart.setHours(DAY_START_HOUR, 0, 0, 0);
      const now = this.getBookingNow();
      for (let i = 0; i < this.totalSlots; i++) {
        const slotStart = new Date(rangeStart.getTime() + i * this.slotMinutes * 60000);
        const slotEnd = new Date(slotStart.getTime() + this.slotMinutes * 60000);
        const inOpen = this.isInOpenRange(room, slotStart, slotEnd);
        const booking = this.findBooking(room, slotStart, slotEnd);
        let status = 'free';
        let effectiveStart = null;
        let title = `${this.formatTime(slotStart)}–${this.formatTime(slotEnd)}`;
        if (!inOpen) {
          status = 'closed';
          title += ' · 未开放';
        } else if (this.isSelectedPast || (this.isSelectedToday && slotEnd <= now)) {
          status = 'past';
          title += ' · 已过';
        } else if (booking) {
          status = booking.Status === 10 ? 'pending' : 'busy';
          title = `${booking.Subject}（${booking.BookerName}）`;
        } else if (this.isSelectedToday && slotStart < now) {
          effectiveStart = new Date(now.getTime());
          title = `${this.formatTime(effectiveStart)}–${this.formatTime(slotEnd)} · 从当前时间起可约`;
        } else {
          title += ' · 点击/拖选';
        }
        slots.push({ slotStart, slotEnd, status, title, booking, effectiveStart });
      }
      return slots;
    },
    getRoomOpenRanges(room) {
      if (!room) return [];
      return room.OpenRanges || room.openRanges || [];
    },
    getOpenRangeStart(range) {
      if (!range) return null;
      return range.StartTime != null ? range.StartTime : range.startTime;
    },
    getOpenRangeEnd(range) {
      if (!range) return null;
      return range.EndTime != null ? range.EndTime : range.endTime;
    },
    normalizeOpenRangeTime(val) {
      if (val == null || val === '') return null;
      if (val instanceof Date && !Number.isNaN(val.getTime())) {
        const base = new Date(`${this.selectedDate}T00:00:00`);
        base.setHours(val.getHours(), val.getMinutes(), val.getSeconds(), 0);
        return base;
      }
      const text = String(val).trim();
      // API 默认格式：yyyy-MM-dd HH:mm:ss
      const spaceDateTimeMatch = text.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{1,2}:\d{2}(?::\d{2})?)$/);
      if (spaceDateTimeMatch) {
        const timePart = spaceDateTimeMatch[2].length === 5 ? `${spaceDateTimeMatch[2]}:00` : spaceDateTimeMatch[2];
        const d = new Date(`${this.selectedDate}T${timePart}`);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      if (text.indexOf('T') >= 0) {
        const parsed = new Date(text);
        if (!Number.isNaN(parsed.getTime())) {
          const base = new Date(`${this.selectedDate}T00:00:00`);
          base.setHours(parsed.getHours(), parsed.getMinutes(), parsed.getSeconds(), 0);
          return base;
        }
      }
      const timeOnlyMatch = text.match(/^(\d{1,2}:\d{2}(?::\d{2})?)$/);
      if (timeOnlyMatch) {
        const timePart = timeOnlyMatch[1].length === 5 ? `${timeOnlyMatch[1]}:00` : timeOnlyMatch[1];
        const d = new Date(`${this.selectedDate}T${timePart}`);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      return null;
    },
    isSlotInOpenRange(room, slotStart, slotEnd) {
      const ranges = this.getRoomOpenRanges(room);
      if (!ranges.length) return false;
      return ranges.some(r => {
        const s = this.normalizeOpenRangeTime(this.getOpenRangeStart(r));
        const e = this.normalizeOpenRangeTime(this.getOpenRangeEnd(r));
        if (!s || !e) return false;
        return slotStart < e && slotEnd > s;
      });
    },
    isRangeInOpen(room, start, end) {
      const ranges = this.getRoomOpenRanges(room);
      if (!ranges.length) return false;
      return ranges.some(r => {
        const s = this.normalizeOpenRangeTime(this.getOpenRangeStart(r));
        const e = this.normalizeOpenRangeTime(this.getOpenRangeEnd(r));
        if (!s || !e) return false;
        return start < e && end > s;
      });
    },
    findBookingInRange(room, start, end) {
      return (room.Bookings || []).find(b => {
        const bs = new Date(b.StartTime);
        const be = new Date(b.EndTime);
        return bs < end && be > start;
      });
    },
    parseOpenRangeTime(val) {
      return this.normalizeOpenRangeTime(val);
    },
    isInOpenRange(room, slotStart, slotEnd) {
      return this.isSlotInOpenRange(room, slotStart, slotEnd);
    },
    findBooking(room, slotStart, slotEnd) {
      return (room.Bookings || []).find(b => {
        const bs = new Date(b.StartTime);
        const be = new Date(b.EndTime);
        return bs < slotEnd && be > slotStart;
      });
    },
    /** 按格子+间隙定位占用条，避免百分比与 gap 错位导致右侧溢出。最后更新：2026-07-18 */
    blockStyle(bk) {
      const base = new Date(`${this.selectedDate}T00:00:00`);
      const rangeStart = new Date(base);
      rangeStart.setHours(DAY_START_HOUR, 0, 0, 0);
      const rangeEnd = new Date(base);
      rangeEnd.setHours(DAY_END_HOUR, 0, 0, 0);
      const bs = Math.max(new Date(bk.StartTime).getTime(), rangeStart.getTime());
      const be = Math.min(new Date(bk.EndTime).getTime(), rangeEnd.getTime());
      if (be <= bs) return { display: 'none' };

      const gap = 2;
      const slotW = this.slotWidthPx;
      const slotMs = this.slotMinutes * 60000;
      const trackWidth = this.totalSlots * slotW + (this.totalSlots - 1) * gap;
      if (trackWidth <= 0) return { display: 'none' };

      const startSlot = (bs - rangeStart.getTime()) / slotMs;
      const endSlot = (be - rangeStart.getTime()) / slotMs;
      const leftPx = startSlot * (slotW + gap);
      const widthPx = Math.max(endSlot * (slotW + gap) - gap - leftPx, slotW * 0.5);
      const left = Math.max(0, Math.min(leftPx, trackWidth));
      const width = Math.max(0, Math.min(widthPx, trackWidth - left));
      return { left: `${(left / trackWidth) * 100}%`, width: `${(width / trackWidth) * 100}%` };
    },
    submitBooking() {
      if (!this.form.slotStart || !this.form.RoomId) return;
      const { start, end, now } = this.buildSubmitTimeRange();
      const dayEnd = new Date(`${this.selectedDate}T00:00:00`);
      dayEnd.setHours(DAY_END_HOUR, 0, 0, 0);
      if (end > dayEnd) {
        this.$message.warning(`结束时间不能超过 ${DAY_END_HOUR}:00`);
        return;
      }
      const check = this.validateSlotRange(this.form.RoomId, start, end, true, now);
      if (!check.ok) {
        this.$message.warning(check.msg);
        return;
      }
      const startTime = this.formatDateTime(start);
      const endTime = this.formatDateTime(end);
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submitLoading = true;
        axios.post(`${apiBase}/api/MeetingBooking/QuickCreate`, {
          RoomId: this.form.RoomId,
          Subject: this.form.Subject,
          BookerTeacherMasterId: this.form.BookerTeacherMasterId,
          StartTime: startTime,
          EndTime: endTime,
          Remark: this.form.Remark,
          NotifyType: this.form.NotifyType,
          Participants: this.buildParticipants()
        }).then(res => {
          this.submitLoading = false;
          if (res.data.success) {
            this.$message.success(res.data.msg || '预约成功');
            this.dialogVisible = false;
            this.loadTimeline();
            this.$emit('success');
          } else {
            this.$message.error(res.data.msg || '预约失败');
          }
        }).catch(() => { this.submitLoading = false; });
      });
    },
    resetForm() {
      this.form = {
        RoomId: null, roomName: '', slotStart: null, durationMinutes: this.slotMinutes || DEFAULT_SLOT_MINUTES,
        StartTime: '', EndTime: '', BookerTeacherMasterId: null, Subject: '', Remark: '', NotifyType: 1
      };
      this.participants = [];
      if (this.$refs.participantPicker) this.$refs.participantPicker.reset();
    },
    formatTime(d) {
      return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    },
    formatDateTime(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const sec = String(d.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${day} ${this.formatTime(d)}:${sec}`;
    }
  }
};
</script>

<style scoped>
.qb-panel.is-embedded {
  border: none;
  box-shadow: none !important;
  border-radius: 12px;
  overflow: hidden;
  background: #f8fafc;
}

.qb-panel >>> .el-card__body {
  padding: 0;
}

.qb-panel-inner.is-embedded {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.qb-panel-content.is-embedded {
  flex: 0 1 auto;
  min-height: 0;
}

/* 顶部工具栏 */
.qb-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 16px;
  font-size: 13px;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
  background: #fafbfc;
}

.qb-toolbar {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px 16px;
  padding: 14px 18px;
  font-size: 13px;
  color: #64748b;
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 55%, #ffffff 100%);
  border-bottom: 1px solid #dbeafe;
}

.qb-toolbar__room {
  justify-self: start;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}

.qb-toolbar__date {
  justify-self: center;
  display: flex;
  align-items: center;
  gap: 10px;
}

.qb-toolbar__actions {
  justify-self: end;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.qb-toolbar__room-label {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.qb-toolbar__room-ctrl {
  width: 220px;
  min-width: 180px;
  max-width: 280px;
}

.qb-toolbar__room-ctrl .el-input__inner {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 30px;
}

.qb-toolbar__room-meta {
  flex-shrink: 0;
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.qb-room-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.qb-room-option__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qb-room-option__meta {
  flex-shrink: 0;
  font-size: 12px;
  color: #94a3b8;
}

.qb-meta__left,
.qb-toolbar__date {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.qb-toolbar__date-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 140px;
}

.qb-toolbar__day {
  font-size: 16px;
  font-weight: 700;
  color: #1e3a8a;
  line-height: 1.2;
}

.qb-toolbar__sub {
  font-size: 12px;
  color: #64748b;
}

.qb-nav-btn {
  width: 32px;
  height: 32px;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  background: #fff;
  color: #3b82f6;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;
}

.qb-nav-btn:hover:not(:disabled) {
  background: #eff6ff;
  border-color: #93c5fd;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.12);
}

.qb-nav-btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  box-shadow: none;
}

.qb-meta__actions,
.qb-toolbar__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.qb-date-picker-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.qb-date-picker-wrap > .el-icon-date {
  position: absolute;
  left: 10px;
  z-index: 1;
  font-size: 14px;
  color: #64748b;
  pointer-events: none;
}

.qb-date-picker-wrap >>> .el-input__inner {
  padding-left: 30px;
  border-radius: 8px;
  border-color: #e2e8f0;
}

.qb-date-picker-wrap >>> .el-input__inner:focus {
  border-color: #93c5fd;
}

.qb-date-picker {
  width: 132px;
}

.qb-refresh-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.qb-refresh-btn i {
  font-size: 14px;
}

.qb-meta__date {
  font-weight: 600;
  color: #1e3a8a;
}

.qb-meta__sep {
  margin: 0 6px;
  color: #cbd5e1;
}

/* 左右分栏 */
.qb-split {
  display: flex;
  min-height: 420px;
}

.qb-split.is-embedded {
  min-height: auto;
  padding-bottom: 12px;
}

.qb-rooms {
  width: 200px;
  flex-shrink: 0;
  border-right: 1px solid #e2e8f0;
  background: #fafbfc;
  padding: 12px 0;
  max-height: 560px;
  overflow-y: auto;
}

.qb-rooms__title {
  padding: 0 14px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.qb-room-item {
  display: block;
  width: 100%;
  padding: 12px 14px;
  border: none;
  border-left: 3px solid transparent;
  background: transparent;
  text-align: left;
  cursor: pointer;
  position: relative;
  transition: background 0.15s, border-color 0.15s;
}

.qb-room-item:hover {
  background: #f1f5f9;
}

.qb-room-item.is-active {
  background: #fff;
  border-left-color: #3b82f6;
  box-shadow: inset 0 0 0 1px #e2e8f0;
}

.qb-room-item__name {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.35;
}

.qb-room-item__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 12px;
  color: #94a3b8;
}

.qb-room-item__badge {
  position: absolute;
  top: 12px;
  right: 12px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #3b82f6;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
}

.qb-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 16px 20px 20px;
}

.qb-main.is-embedded {
  padding: 16px 18px;
  background: #fff;
}

.qb-room-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.qb-room-picker {
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  background: #f8fafc;
}

.qb-room-picker__label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  color: #64748b;
}

.qb-room-picker__list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.qb-room-picker__item {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #fff;
  font-size: 13px;
  color: #334155;
  cursor: pointer;
  transition: all 0.15s ease;
}

.qb-room-picker__item:hover {
  border-color: #93c5fd;
  background: #eff6ff;
}

.qb-room-picker__item.is-active {
  border-color: #3b82f6;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  color: #1d4ed8;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.12);
}

.qb-room-picker__meta {
  font-size: 11px;
  color: #94a3b8;
}

.qb-room-picker__item.is-active .qb-room-picker__meta {
  color: #60a5fa;
}

.qb-room-picker__badge {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #3b82f6;
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
}

.qb-room-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.15s ease;
}

.qb-room-tab:hover {
  border-color: #93c5fd;
  background: #eff6ff;
}

.qb-room-tab.is-active {
  border-color: #3b82f6;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
}

.qb-room-tab__name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.qb-room-tab__meta {
  font-size: 11px;
  color: #64748b;
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
}

.qb-room-tab__badge {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #3b82f6;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
}

.qb-main__toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.qb-main__intro {
  min-width: 0;
}

.qb-main__title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.qb-main.is-embedded .qb-main__title {
  font-size: 15px;
}

.qb-main__hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: #94a3b8;
}

.qb-legend {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #64748b;
  flex-shrink: 0;
  padding: 8px 12px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #f1f5f9;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.qb-legend span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.qb-legend__now {
  margin-left: 2px;
  padding: 0 4px;
}

.qb-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.qb-dot.is-free { background: #4ade80; }
.qb-dot.is-busy { background: #f87171; }
.qb-dot.is-pending { background: #fbbf24; }
.qb-dot.is-past { background: #f8fafc; box-shadow: inset 0 0 0 1px #cbd5e1; }
.qb-dot.is-closed { background: #e2e8f0; }

/* 代订弹窗摘要 */
.qb-dialog-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px 14px;
  border-radius: 10px;
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%);
  border: 1px solid #dbeafe;
}

.qb-dialog-summary__icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #fff;
  color: #3b82f6;
  font-size: 18px;
  box-shadow: 0 1px 4px rgba(59, 130, 246, 0.12);
}

.qb-dialog-summary__body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.qb-dialog-summary__room {
  font-size: 14px;
  font-weight: 600;
  color: #1e3a8a;
}

.qb-dialog-summary__time {
  font-size: 13px;
  color: #64748b;
  font-variant-numeric: tabular-nums;
}

/* 时间条 */
.qb-strip-wrap {
  border: 1px solid #eef2f7;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  min-width: 0;
}

.qb-strip-wrap.is-fluid {
  border-color: #e8eef5;
  box-shadow: none;
  border-radius: 10px;
  background: #f8fafc;
}

.qb-strip-wrap.is-fluid .qb-strip-scroll {
  background: #fff;
}

.qb-strip-wrap.is-fluid .qb-strip__hours {
  padding: 8px 8px 4px;
  background: #f8fafc;
  border-bottom: 1px solid #eef2f7;
}

.qb-strip-wrap.is-fluid .qb-strip__hour {
  font-size: 10px;
  line-height: 14px;
  color: #94a3b8;
  font-weight: 500;
}

.qb-strip-wrap.is-fluid .qb-strip__track {
  padding: 22px 8px 10px;
  background: #fff;
}

.qb-strip-wrap.is-fluid .qb-scroll-rail {
  padding: 0 8px 6px;
  background: #f8fafc;
  border-top: 1px solid #eef2f7;
}

.qb-strip-wrap.is-fluid .qb-scroll-rail__track {
  height: 4px;
  border-radius: 2px;
  background: #e2e8f0;
}

.qb-strip-wrap.is-fluid .qb-scroll-rail__thumb {
  top: 0;
  height: 4px;
  min-width: 28px;
  border-radius: 2px;
  background: #94a3b8;
}

.qb-strip-wrap.is-fluid .qb-scroll-rail__thumb:hover {
  background: #64748b;
}

.qb-strip-wrap.is-fluid .qb-now__bubble {
  top: 0;
  padding: 1px 7px;
  font-size: 10px;
  line-height: 16px;
  box-shadow: 0 1px 4px rgba(37, 99, 235, 0.28);
}

.qb-strip-wrap.is-fluid .qb-now__line {
  top: 20px;
  bottom: 10px;
  width: 1px;
}

.qb-strip-wrap.is-fluid .qb-events {
  top: 22px;
  bottom: 10px;
  left: 8px;
  right: 8px;
  overflow: hidden;
}

.qb-strip-wrap.is-fluid .qb-event {
  max-height: 60px;
  border-radius: 5px;
}

.qb-strip-wrap.is-fluid .qb-event__title {
  display: none;
}

.qb-strip-wrap.is-fluid .qb-cell {
  height: 60px;
  min-height: 60px;
  max-height: 60px;
  border-radius: 5px;
}

.qb-strip-wrap.is-fluid .qb-cell.is-free:hover {
  transform: none;
  background: #4ade80;
}

.qb-strip-wrap.is-fluid .qb-cell.is-current.is-free {
  background: linear-gradient(90deg, #f1f5f9 0%, #f1f5f9 38%, #86efac 38%, #86efac 100%);
  box-shadow: inset 0 0 0 1px #4ade80;
}

.qb-strip-wrap.is-fluid .qb-cell.is-booking-selected {
  box-shadow: inset 0 0 0 2px #2563eb, 0 0 0 2px rgba(37, 99, 235, 0.28);
}

.qb-main.is-embedded .qb-main__toolbar {
  margin-bottom: 10px;
  align-items: center;
}

.qb-main.is-embedded .qb-legend {
  padding: 5px 10px;
  gap: 8px;
  font-size: 11px;
  border-radius: 8px;
}

.qb-list.is-compact {
  margin-top: 12px;
  flex: 0 0 auto;
  border-color: #f1f5f9;
  background: #fafbfc;
}

.qb-strip-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  min-width: 0;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  touch-action: pan-x;
  scrollbar-width: none;
}

.qb-strip-scroll::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.qb-scroll-rail {
  padding: 6px 10px 10px;
  background: #fff;
}

.qb-scroll-rail__track {
  position: relative;
  height: 18px;
  border-radius: 9px;
  background: #eef2f7;
  cursor: pointer;
  user-select: none;
}

.qb-scroll-rail__thumb {
  position: absolute;
  top: 3px;
  left: 0;
  height: 12px;
  min-width: 56px;
  border-radius: 6px;
  background: #94a3b8;
  cursor: pointer;
  transition: background 0.15s;
}

.qb-scroll-rail__thumb:hover {
  background: #64748b;
}

.qb-scroll-rail__thumb:active {
  background: #475569;
  cursor: grabbing;
}

.qb-scroll-rail__track:hover {
  cursor: pointer;
}

.qb-strip {
  position: relative;
  flex-shrink: 0;
}

.qb-strip__hours {
  padding: 4px 6px 0;
  border-bottom: none;
  background: #fff;
}

.qb-strip__hour {
  padding: 0 0 0 2px;
  font-size: 11px;
  line-height: 18px;
  color: #64748b;
  border: none;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

.qb-strip__track {
  position: relative;
  padding: 22px 6px 4px;
  background: #fafbfc;
  box-sizing: border-box;
}

.qb-cell {
  border: none;
  border-radius: 6px;
  box-sizing: border-box;
  min-height: 56px;
  transition: background 0.12s, box-shadow 0.12s, transform 0.12s;
  position: relative;
  pointer-events: auto;
}

.qb-cell.is-clickable {
  cursor: pointer;
  touch-action: manipulation;
}

.qb-cell.is-hour {
  border-left: none;
}

.qb-cell.is-free {
  z-index: 8;
  cursor: pointer;
  background: #86efac;
  box-shadow: inset 0 0 0 1px #4ade80;
}

.qb-cell.is-free:hover {
  background: #4ade80;
  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.22), inset 0 0 0 1px #22c55e;
  transform: translateY(-1px);
  z-index: 9;
}

.qb-cell.is-current.is-free {
  box-shadow: inset 3px 0 0 #3b82f6;
}

.qb-cell.is-selecting {
  background: #4ade80 !important;
  box-shadow: 0 0 0 2px #22c55e;
}

.qb-cell.is-busy { background: #fca5a5; }
.qb-cell.is-pending { background: #fde68a; }
.qb-cell.is-selectable {
  cursor: pointer;
}
.qb-cell.is-booking-selected {
  z-index: 10;
  box-shadow: inset 0 0 0 2px #2563eb, 0 0 0 2px rgba(37, 99, 235, 0.3);
}
.qb-cell.is-past {
  z-index: 2;
  background: #f8fafc;
  box-shadow: inset 0 0 0 1px #e2e8f0;
  cursor: not-allowed;
}
.qb-cell.is-closed {
  z-index: 2;
  background: #f1f5f9;
  box-shadow: inset 0 0 0 1px #cbd5e1;
  cursor: not-allowed;
}

.qb-now {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 0;
  z-index: 5;
  pointer-events: none;
  transform: translateX(-50%);
}

.qb-now,
.qb-now__bubble,
.qb-now__line {
  pointer-events: none !important;
}

.qb-now__bubble {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  padding: 3px 10px;
  border-radius: 999px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  line-height: 18px;
  box-shadow: 0 2px 10px rgba(37, 99, 235, 0.35);
}

.qb-now__line {
  position: absolute;
  top: 24px;
  bottom: 4px;
  left: 50%;
  width: 2px;
  transform: translateX(-50%);
  border-radius: 1px;
  background: linear-gradient(180deg, #3b82f6 0%, rgba(59, 130, 246, 0.15) 100%);
}

.qb-events {
  position: absolute;
  top: 22px;
  bottom: 4px;
  left: 6px;
  right: 6px;
  overflow: hidden;
  pointer-events: none !important;
  z-index: 4;
}

.qb-events,
.qb-event,
.qb-event * {
  pointer-events: none !important;
}

.qb-event {
  position: absolute;
  top: 0;
  height: 100%;
  max-height: 56px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  background: #fecaca;
  border-left: 3px solid #ef4444;
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.18);
  overflow: hidden;
}

.qb-event.is-pending {
  background: #fde68a;
  border-left-color: #f59e0b;
  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.18);
}

.qb-event__title {
  font-size: 12px;
  font-weight: 600;
  color: #7f1d1d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qb-event.is-pending .qb-event__title {
  color: #92400e;
}

.qb-event.is-selected {
  box-shadow: inset 0 0 0 2px #2563eb, 0 0 0 2px rgba(37, 99, 235, 0.35);
  z-index: 6;
}

/* 当日预约列表 */
.qb-list {
  margin-top: 16px;
  flex: 1;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.qb-list__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  background: #fafbfc;
  border-bottom: 1px solid #e2e8f0;
}

.qb-list__head i {
  margin-right: 4px;
  color: #94a3b8;
  font-weight: normal;
}

.qb-list.is-compact .qb-list__head {
  padding: 8px 12px;
  font-size: 12px;
  background: transparent;
  border-bottom-color: #f1f5f9;
}

.qb-list__count {
  font-weight: 500;
  color: #94a3b8;
}

.qb-list__toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  background: #fff;
}

.qb-list__search {
  flex: 1;
  min-width: 120px;
}

.qb-list__status {
  width: 108px;
  flex-shrink: 0;
}

.qb-list__pager {
  padding: 8px 12px 10px;
  text-align: right;
  border-top: 1px solid #f1f5f9;
  background: #fafbfc;
}

.qb-list__body.is-paged.is-chips {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  max-height: none;
  padding: 10px 12px;
  overflow: visible;
}

.qb-list__body {
  max-height: 280px;
  overflow-y: auto;
}

.qb-list__body.is-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: none;
  padding: 10px 12px;
  overflow: visible;
}

.qb-booking {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border-bottom: 1px solid #f8fafc;
}

.qb-booking .qb-booking__info {
  flex: 1;
  min-width: 0;
}

.qb-booking.is-chip {
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  min-width: 160px;
  flex: 1 1 160px;
  border-bottom: 1px solid #e2e8f0;
}

.qb-booking__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.qb-booking__cancel {
  flex-shrink: 0;
  padding: 0 4px;
  color: #ef4444;
}

.qb-booking__cancel:hover,
.qb-booking__cancel:focus {
  color: #dc2626;
}

.qb-booking:last-child {
  border-bottom: none;
}

.qb-booking.is-pending {
  background: #fffbeb;
}

.qb-booking.is-cancelled {
  background: #f8fafc;
  border-color: #e2e8f0;
  opacity: 0.92;
}

.qb-booking.is-cancelled .qb-booking__subject,
.qb-booking.is-cancelled .qb-booking__time {
  color: #94a3b8;
}

.qb-booking.is-noshow {
  background: #fef2f2;
}

.qb-booking.is-rejected {
  background: #fff1f2;
}

.qb-booking.is-chip.is-pending {
  border-color: #fde68a;
  background: #fffbeb;
}

.qb-booking__tags {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.qb-booking.is-chip.is-selected,
.qb-booking.is-selected {
  border-color: #2563eb !important;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.28);
  background: #eff6ff !important;
}

.qb-booking.is-chip {
  cursor: pointer;
}

.qb-booking__time {
  flex-shrink: 0;
  width: 100px;
  font-size: 13px;
  font-weight: 600;
  color: #1e3a8a;
  font-variant-numeric: tabular-nums;
}

.qb-booking.is-chip .qb-booking__time {
  width: auto;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #eff6ff;
}

.qb-booking__subject {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.qb-booking.is-chip .qb-booking__subject {
  font-size: 13px;
}

.qb-booking__meta {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
}

.qb-list__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 32px 16px;
  font-size: 13px;
  color: #94a3b8;
}

.qb-list__empty.is-compact {
  padding: 14px 12px;
  font-size: 12px;
  justify-content: flex-start;
  background: transparent;
}

.qb-list__empty i {
  font-size: 18px;
  color: #cbd5e1;
}

.qb-list__empty.is-compact i {
  font-size: 16px;
}

.qb-empty {
  padding: 48px;
  text-align: center;
  color: #94a3b8;
}

.qb-empty i {
  font-size: 40px;
  color: #cbd5e1;
}

.qb-empty p {
  margin: 12px 0 16px;
}

@media (max-width: 900px) {
  .qb-split:not(.is-embedded) {
    flex-direction: column;
  }

  .qb-rooms {
    width: 100%;
    max-height: 160px;
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px;
  }

  .qb-rooms__title {
    width: 100%;
    padding: 0 0 4px;
  }

  .qb-room-item {
    width: auto;
    flex: 1 1 140px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    border-left: 1px solid #e2e8f0;
  }

  .qb-room-item.is-active {
    border-color: #3b82f6;
    border-left-color: #3b82f6;
  }

  .qb-main__toolbar {
    flex-direction: column;
  }

  .qb-legend {
    width: 100%;
    flex-wrap: wrap;
  }
}

@media (max-width: 900px) {
  .qb-toolbar {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 10px;
  }

  .qb-toolbar__room,
  .qb-toolbar__date,
  .qb-toolbar__actions {
    justify-self: center;
    width: 100%;
    justify-content: center;
  }

  .qb-toolbar__room-ctrl {
    flex: 1;
    width: auto;
    max-width: none;
  }

  .qb-toolbar__actions {
    flex-wrap: wrap;
  }
}
</style>
